import { StyleSheet } from "react-native";
import {styleVars} from "../app-style-vars";

export default StyleSheet.create({

  pageContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: styleVars.statusBarHeight(),
    backgroundColor: '#fff', /** not to override status bar background */
    /*overflow: 'hidden',*/
  },
  pageContainerFullScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },

  fixedHeaderContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 1,
    paddingTop: styleVars.statusBarHeight(),
  },

  pageScrollContainer: {
    alignSelf: 'stretch',
    backgroundColor: '#ffffff',
  },

  inScrollContentContainer: {
    minHeight: '100%'
  },

  inScrollBottomContentContainer: {
    position: 'absolute',
    bottom: 0,
  },

  pageInfoContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: styleVars.rem(.25),
    paddingHorizontal: styleVars.rem(.75),
    borderBottomColor: styleVars.boschLightGray,
    borderBottomWidth: 1,
    backgroundColor: styleVars.boschLightGrayW75,
  },

  pageInfoText: {
    color: '#000',
    fontSize: styleVars.rem(.875),
    textAlign: 'center'
  },

  pageContentSlotContainer: {
    marginVertical: styleVars.rem(.75),
    marginHorizontal: styleVars.rem(.5),
  },

  slotContainerTitleText: {
    fontSize: styleVars.rem(1.25),
    fontWeight: 'bold',
    paddingBottom: styleVars.rem(.5),
  },

  withBoundaries: {
    padding: 2,
    borderWidth: 2,
    borderColor: '#cacaca',
    borderStyle: 'dashed'
  },
})
